import Vue from 'vue'
import VueRouter from 'vue-router'


import Home from '../views/Activity/Home'
import About from '../views/Activity/About'
import Founder from '../views/Activity/Founder'
import ReligiousFormation from '../views/Activity/ReligiousFormation'

import Contact from '../views/Activity/Contact'
import Login from '../views/Activity/Login'  
import Sisters from '../views/Activity/Sisters'
import Sister from '../views/Activity/Sister'
import GalleryItems from '../views/Activity/GalleryItems'
import GalleryItem from '../views/Activity/GalleryItem'
import Communities from '../views/Activity/Communities'
import Community from '../views/Activity/Community'
import Services from '../views/Activity/Services'
import Service from '../views/Activity/Service'
import News from '../views/Activity/News'
import New from '../views/Activity/New'
import Events from '../views/Activity/Events'

//CPANEL
import Cpanel from '../views/Activity/cpanel/Cpanel'   
import Cpanel_Services from '../views/Activity/cpanel/Cpanel_Services' 
import Cpanel_Events from '../views/Activity/cpanel/Cpanel_Events'
import Cpanel_News from '../views/Activity/cpanel/Cpanel_News'  
import Cpanel_sms from '../views/Activity/cpanel/Cpanel_sms' 
import Cpanel_Sisters from '../views/Activity/cpanel/Cpanel_Sisters' 
import Cpanel_Communities from '../views/Activity/cpanel/Cpanel_Communities' 
import Cpanel_GalleryImages from '../views/Activity/cpanel/Cpanel_GalleryImages' 
import Cpanel_visiters from '../views/Activity/cpanel/Cpanel_visiters'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }, 
  {
    path: '/about',
    name: 'About',
    component: About
  }, 
  {
    path: '/about/founder',
    name: 'Founder',
    component: Founder
  }, 
  {
    path: '/religious-formation',
    name: 'ReligiousFormation',
    component: ReligiousFormation
  }, 
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }, 
  {
    path: '/login',
    name: 'Login',
    component: Login
  },  
  {
    path: '/about/sisters',
    name: 'Sisters',
    component: Sisters
  }, 
  {
    path: '/events',
    name: 'Events',
    component: Events
  }, 
  {
    path: '/news',
    name: 'News',
    component: News
  }, 
  {
    path: '/news/:id',
    name: 'News.',
    props: true,
    component: New
  }, 
  {
    path: '/about/sisters/:id',
    name: 'Sister',
    props: true,
    component: Sister
  }, 
  {
    path: '/about/communities',
    name: 'Communities',
    props: true,
    component: Communities
  }, 
  {
    path: '/about/communities/:id',
    name: 'Community',
    props: true,
    component: Community
  }, 
  {
    path: '/gallery',
    name: 'Gallery',
    component: GalleryItems
  }, 
  {
    path: '/gallery/:id',
    name: 'GalleryItems',
    props: true,
    component: GalleryItem
  },
  
  {
    path: '/services',
    name: 'Services',
    component: Services
  }, 
  {
    path: '/services/:id',
    name: 'Service',
    props: true,
    component: Service
  }, 
   
  //cpanel
  {
    path: '/cpanel',
    name: 'Cpanel',
    component: Cpanel
  }, 
  {
    path: '/cpanel/services',
    name: 'Cpanel Services',
    component: Cpanel_Services
  },
  {
    path: '/cpanel/events',
    name: 'Cpanel Events',
    component: Cpanel_Events
  },
  {
    path: '/cpanel/news',
    name: 'Cpanel News',
    component: Cpanel_News
  },
  {
    path: '/cpanel/sms',
    name: 'Cpanel SMS',
    component: Cpanel_sms
  },
  {
    path: '/cpanel/sisters',
    name: 'Cpanel Sisters',
    component: Cpanel_Sisters
  },
  {
    path: '/cpanel/communities',
    name: 'Cpanel Communities',
    component: Cpanel_Communities
  },
  {
    path: '/cpanel/images',
    name: 'Cpanel Gallery Images',
    component: Cpanel_GalleryImages
  },
  {
    path: '/cpanel/visiters',
    name: 'SMS Visiters',
    component: Cpanel_visiters
  }, 
  
]

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes,
  mode:"history"
})

export default router
